import { settings } from 'settings';
import Fetch from 'utils/fetch';

export async function fetchUpdateInbound(
  inboundId: string,
  name: string,
  accountIdsAsList: number[],
  assignedCourierId: number
): Promise<boolean> {
  try {
    const response: Response = await Fetch.put({
      url: `${settings.newApiUrl}/inbound/${inboundId}`,
      body: {
        name: `${name}`,
        accountIdsAsList: accountIdsAsList,
        assignedCourierId: assignedCourierId,
      },
    });

    if (response.ok) {
      return true;
    }
  } catch (error) {
    return false;
  }
}

export async function fetchCreateInbound(
  name: string,
  accountIdsAsList: number[],
  assignedCourierId: number
): Promise<boolean> {
  try {
    const response: Response = await Fetch.post({
      url: `${settings.newApiUrl}/inbound`,
      body: {
        name: `${name}`,
        accountIdsAsList: accountIdsAsList,
        assignedCourierId: assignedCourierId,
      },
    });

    if (response.ok) {
      return true;
    }
  } catch (error) {
    return false;
  }
}
